/**
 * useQuickActions
 *
 * Consumes QuickActionsContext. Must be used within QuickActionsProvider
 * so that only one GET /api/quick-actions runs per session (no spam from
 * multiple SidebarItemMenu / ToolDropdown instances).
 */

import { useQuickActionsContext } from '@/context/quick-actions'

export type { QuickAction } from '@/context/quick-actions'

export type UseQuickActionsReturn = ReturnType<typeof useQuickActionsContext>

export function useQuickActions(): UseQuickActionsReturn {
  return useQuickActionsContext()
}
